"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteBucketCorsInput_1 = require("./DeleteBucketCorsInput");
var DeleteBucketCorsOutput_1 = require("./DeleteBucketCorsOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteBucketCors = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteBucketCors",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}?cors"
    },
    input: {
        shape: DeleteBucketCorsInput_1.DeleteBucketCorsInput
    },
    output: {
        shape: DeleteBucketCorsOutput_1.DeleteBucketCorsOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteBucketCors.js.map